import { sound, Sound, PlayOptions, IMediaInstance } from "@pixi/sound";

export class SoundManager {

    public static play(alias: string, options?: PlayOptions | (() => void)): IMediaInstance | Promise<IMediaInstance> | null {
        if (!sound.exists(alias)) {
            console.warn(`[SoundManager] Cannot play: Sound "${alias}" does not exist.`);
            return null;
        }
        return sound.play(alias, options);
    }

    /**
     * Safely stops a sound by its alias.
     */
    public static stop(alias: string): void {
        if (!sound.exists(alias)) {
            console.warn(`[SoundManager] Cannot stop: Sound "${alias}" does not exist.`);
            return;
        }
        sound.stop(alias);
    }

    /**
     * Safely pauses a sound by its alias.
     */
    public static pause(alias: string): void {
        if (!sound.exists(alias)) {
            console.warn(`[SoundManager] Cannot pause: Sound "${alias}" does not exist.`);
            return;
        }
        sound.pause(alias);
    }

    /**
     * Safely resumes a sound by its alias.
     */
    public static resume(alias: string): void {
        if (!sound.exists(alias)) {
            console.warn(`[SoundManager] Cannot resume: Sound "${alias}" does not exist.`);
            return;
        }
        sound.resume(alias);
    }

    /**
     * Safely finds a Sound object if it exists.
     */
    public static find(alias: string): Sound | null {
        if (!sound.exists(alias)) {
            console.warn(`[SoundManager] Sound "${alias}" not found in library.`);
            return null;
        }
        return sound.find(alias);
    }

    public static resumeAll(): void {
        sound.resumeAll();
    }

    public static pauseAll(): void {
        sound.pauseAll();
    }
}
